import { useMutation } from '@tanstack/react-query';
import { deleteContainerAppAPI } from '../apis';
import { toast } from 'react-toastify';

const useDeleteContainerApp = ({ callbackAfterSuccess = () => {} }) => {
  const mutationData = useMutation({
    mutationFn: deleteContainerAppAPI,
    onSuccess: () => {
      toast.success('Delete Container App successfully');
      callbackAfterSuccess();
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Delete Container App:', error);
    },
  });

  return mutationData;
};

export default useDeleteContainerApp;
